import { Link } from "gatsby"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Container, Navbar, Nav } from "react-bootstrap"
import queryString from "query-string"
import Cookies from "js-cookie"
import Logo from "../images/logo.svg"
import StickyBox from "react-sticky-box"
import { AnchorLink } from "gatsby-plugin-anchor-links";

//import PhBanner from "./ph-banner"

// Toggle sidebar menu
/*
const handleClick = () => {
  let sidebarClass = document.querySelector(".sidebar-container");
  sidebarClass.classList.toggle("open");
};
*/

const DocHeader = ({ siteTitle, ...props }) => {
  const [isSticky, setSticky] = useState(false);

  // Set cookie
  const setCookie = (name, value, expires = 30) => {

    if( process.env.NODE_ENV == 'development' ) {
      Cookies.set(name, value, {
        expires,
        /*path: '/',
        domain: 'scrapeowl.test',
        secure: false,
        sameSite: 'none'*/
      })
    } else {
      Cookies.set(name, value, {
        expires,
        path: '/',
        domain: '.scrapeowl.com',
        secure: true,
        sameSite: 'none'
      })
    }
  }

  // Check if cookie exists
  const checkCookieExist = (name) => {
    let cookie = Cookies.get(name)
    if(!cookie || cookie == '') {
      return false
    }

    return true
  }

  // Store refs
  /*useEffect(() => {
    // Parse query strings from location.search (url)
    let queryStr = window.location.search ? queryString.parse(window.location.search) : {}

    // Store referrer
    if(document.referrer != '' && !checkCookieExist('so_referrer')) {
      setCookie('so_referrer', document.referrer);
    }

    // Make sure the query string is there and is object etc
    if(typeof queryStr === 'object' && queryStr) {
      // If it is a "ref" usually used by PH and betalist
      if( Object.prototype.hasOwnProperty.call( queryStr, 'ref' ) ) {
        if(queryStr.ref === 'producthunt') {
          if(!checkCookieExist('so_source')) {
            setCookie('so_source', 'producthunt');
          }
          if(!checkCookieExist('so_medium')) {
            setCookie('so_medium', 'organic');
          }
          if(!checkCookieExist('so_campaign')) {
            setCookie('so_campaign', 'product_launch');
          }
        } else if(queryStr.ref === 'betalist') {
          if(!checkCookieExist('so_source')) {
            setCookie('so_source', 'betalist');
          }
          if(!checkCookieExist('so_medium')) {
            setCookie('so_medium', 'organic');
          }
          if(!checkCookieExist('so_campaign')) {
            setCookie('so_campaign', 'product_launch');
          }
        }
      } else {
        if( Object.prototype.hasOwnProperty.call( queryStr, 'utm_source' ) && !checkCookieExist('so_source') ) {
          setCookie('so_source', queryStr.utm_source);
        }
        if( Object.prototype.hasOwnProperty.call( queryStr, 'so_medium' ) && !checkCookieExist('so_medium') ) {
          setCookie('so_medium', queryStr.utm_medium);
        }
        if( Object.prototype.hasOwnProperty.call( queryStr, 'so_campaign' ) && !checkCookieExist('so_campaign') ) {
          setCookie('so_campaign', queryStr.utm_campaign);
        }
      }
    }

  }, []);*/

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 1) {
        setSticky(true);
      } else {
        setSticky(false);
      }
    });

    return () => {
      window.removeEventListener('scroll', () => { });
    };
  }, []);

  return (
    <React.Fragment>
      <StickyBox offsetTop={0} offsetBottom={20} style={{ zIndex: 99 }} className={isSticky ? 'sticky' : ''} >
        {
          /*<PhBanner />*/
        }
        <header>
          <Container fluid={false}>
            <Navbar bg="" expand="lg">
              <Link
                to="/"
                className="logo">
                <img src={Logo} alt="ScrapeOwl logo" />
              </Link>
              <Navbar.Toggle aria-controls="basic-navbar-nav" />
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ml-lg-5 align-items-center">
                  <Nav.Item className="lefties">
                    <Link to="/docs" activeClassName="active">
                      API Docs
                    </Link>
                  </Nav.Item>
                  <Nav.Item className="lefties">
                    <Link to="/pricing">
                      Pricing
                    </Link>
                  </Nav.Item>
                  <Nav.Item className="lefties">
                    <AnchorLink to="/#faq">
                      FAQ's
                    </AnchorLink>
                  </Nav.Item>
                  {/* <Nav.Item>
                <Link to="/tutorials">
                  Tutorials
                </Link>
              </Nav.Item> */}
                </Nav>
                <Nav className="ml-lg-auto align-items-center">
                  <Nav.Item>
                    <a className="lefties" href="https://app.scrapeowl.com/register">
                      Join ScrapeOwl
                </a>
                  </Nav.Item>
                  <Nav.Item>
                    <a href="https://app.scrapeowl.com/login">
                      Sign In
                </a>
                  </Nav.Item>

                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </Container>
        </header>
      </StickyBox>
    </React.Fragment>
  )
}
DocHeader.propTypes = {
  siteTitle: PropTypes.string,
}

DocHeader.defaultProps = {
  siteTitle: ``,
}

export default DocHeader
